import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import SearchResultSectionImpl from './search-result-section.js';

const { UIView } = MojitoCore.Presentation;

/**
 * Type-grouped search discovery results.
 *
 * @class SearchResultSection
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * `SearchResultSection` prop types.
 *
 * @property {string} title - Section title.
 * @property {object[]} items - Search results in the section.
 * @property {boolean} [isPlayerGroup = false] - Whether the section contains player props.
 * @property {Function} [onNavigate] - Called after result navigation.
 *
 * @memberof Mojito.Applications.Sports.Search.SearchResultSection
 */
const propTypes = {
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    isPlayerGroup: PropTypes.bool,
    onNavigate: PropTypes.func,
};

const defaultProps = {
    isPlayerGroup: false,
    onNavigate: noop,
};

export default UIView('SearchResultSection', SearchResultSectionImpl, propTypes, defaultProps);
